import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BullhornNamespace, LocalFileNamespace, SalesforceNamespace } from 'datasource-service-lib';
import { Namespace } from 'enums-lib';

interface IUploadSourceOption {
  value: string;
  label: string;
  iconClass: string;
  useMaterialIcon: boolean;
}

@Component({
  selector: 'app-upload-source-selector',
  templateUrl: './upload-source-selector.component.html',
  styleUrls: ['./upload-source-selector.component.scss'],
  standalone: false,
})
export class UploadSourceSelectorComponent {
  @Input() fileSection: FormGroup;
  @Input() namespace: Namespace | string;

  protected readonly LocalFileNamespace = LocalFileNamespace;
  // Namespace-specific source metadata keeps template logic stable as providers grow.
  protected readonly datasourceOptionByNamespace: Record<string, IUploadSourceOption> = {
    [Namespace.bullhorn]: {
      value: BullhornNamespace.name,
      label: 'Bullhorn',
      iconClass: 'bhi-bull',
      useMaterialIcon: false,
    },
    [Namespace.salesforce]: {
      value: SalesforceNamespace.name,
      label: 'Salesforce',
      iconClass: 'cloud',
      useMaterialIcon: true,
    },
  };

  get fileConfig(): FormGroup {
    return this.fileSection?.get('config') as FormGroup;
  }

  get datasourceOption(): IUploadSourceOption {
    return this.datasourceOptionByNamespace[this.namespace] ?? this.datasourceOptionByNamespace[Namespace.bullhorn];
  }
}
